import { http, HttpResponse } from 'msw'
import { UnsecuredJWT } from 'jose'
import { StatusCodes } from 'http-status-codes'

import { user } from '@/mocks/data/general/user'

import { api } from '@/utils/constants'

import { LoginPayload, LoginResponse } from '@/types/auth/login'

export const login = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.LOGIN}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = LoginPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(undefined, {
                status: StatusCodes.BAD_REQUEST,
            })
        }

        const jwtContent = {
            zer: 'aze',
        }

        const accessToken = new UnsecuredJWT(jwtContent)
            .setIssuedAt()
            .setExpirationTime('1d')
            .encode()

        const refreshToken = new UnsecuredJWT(jwtContent)
            .setIssuedAt()
            .setExpirationTime('15d')
            .encode()

        return HttpResponse.json<LoginResponse>({
            access: accessToken,
            refresh: refreshToken,
            machine_user_id: user.id,
            client: user.client,
        })
    },
)
